<template>
  <div class="home_intro">
      <div class="body_container">
        <el-row>
            <el-col :span="8">
                <img :src="intro_img" class="intro_img"/>
            </el-col>
            <el-col :span="16" class="cont">
                <div>
                    <h1 v-html="title" class="home_h"></h1>
                    <p v-html="context" class="home_p"></p>
                    <p><span style="font-style:italic;font-size:17px">* This website is free and open to all users and there is no login requirement. </span></p>
                </div>
            </el-col>
        </el-row>
        <div class="func_div">
            <el-row :gutter="30">
                <el-col :span="8" v-for="func of function_des" :key="func.title">
                    <div class="func">
                        <h1 class="func_h">{{func.name}}</h1>
                        <p v-html="func.des" class="func_p"></p>
                        
                        <div  class="func_b">
                            <el-button type="primary" icon="el-icon-s-promotion" class="el-botton" @click="goNavi(func.url)">GET START</el-button>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
  </div>
</template>

<script>
import intro_fig from '@/assets/img/PCGA.png';
export default {
  name: 'home_intro',
  data:function(){
        return {
            title:'PCGA',
            context:'PCGA, phenotype-cell-gene association analysis platform is a web server to simultaneously estimate associated tissues/cell types and \
            genes of complex diseases and traits by GWAS summary statistics. PCGA has included 54 human tissues, 2,214 human single cell types and  \
            4,384 mouse single cell types. Meanwhile, the website has analyzed 1,871 public GWASs of 1,588 unique phenotypes, \
            which could be browsed and searched in the website. \
            The standalone application of PCGA is implemented on the <a href="https://pmglab.top/kggsee" target="_blank" style="color:#0172BC;text-decoration:none">KGGSEE</a>. \
            <a href="#/document" style="color:#0172BC;text-decoration:none">Read More</a> ',
            intro_img:intro_fig,
            function_des:[
                {
                    name:'Analyze',
                    des:'Upload your GWAS summary file to estimate the associated tissues/cell types and genes.',
                    url:'infer_cell',
                    class:'f2'
                },
                {
                    name:'Search',
                    des:'Search the precomputed association landscape by phenotypes, tissues/cell types and genes.',
                    url:'search',
                    class:'f1'
                },
                {
                    name:'Browse',
                    des:'Browse phenotypes and tissues/cell types in the web server.',
                    url:'browse',
                    class:'f1'
                }
            ],
        }
    },
    methods:{
        goNavi:function(url){
            this.$router.push({path:'/'+url});
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home_intro{
    width: 100%;
    /* background: #1c92d2; */
    /* background: -webkit-linear-gradient(to top, #1c92d2,#f2fcfe);  
    background: linear-gradient(to top, #1c92d2, #f2fcfe); */
    background: -webkit-linear-gradient(to top, #22ACF5,#f2fcfe);  
    background: linear-gradient(to top, #22ACF5, #f2fcfe);
    height: 1000px;
    /* margin-bottom: 0px;
    margin-top: 60px; */
}
.intro_img{
    height: 370px;
    /* margin: 50px 100px; */
    margin:130px auto 50px auto;
}

.cont{
    padding-right: 10px;
    padding-left: 50px;
    padding-top: 40px;
}

.home_h{
    font-size: 48px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
}
.home_p{
    font-size: 22px;
    line-height: 36px;
    font-weight: bold;
    font-family: Arial, Helvetica, sans-serif;
    color: #303133;
}

.func_div{
    margin-top: 30px;
}

.func{
    padding-top: 0px;
    padding-bottom:  20px;
    padding-left: 20px;
    padding-right: 20px;
    border: #0172BC 2px solid;
    /* border: #0172BC 2px solid; */
    border-radius: 8px;
    background-color: #314555;
/* background-color: #8ECBEA; */
    color: white;
}
.func_h{
    margin: 0;
    font-size: 24px;
    text-align: center;
    /* border-bottom: gray 1px solid; */
    border-bottom: #0172BC 2px solid;
    padding-bottom: 15px;
    padding-top: 15px;
    font-family: Arial, Helvetica, sans-serif;
    color: #FFFFFF;
    /* background-color: #0172BC; */
}
.func_p{
    font-size: 18px;
    line-height: 24px;
    font-weight: 550;
    font-family: Arial, Helvetica, sans-serif;
    height: 80px;
    color: #F4F4F5;
    /* color: #000000; */
}
.func_b{
    text-align: left;
}
.el-botton{
    background-color: #0072BC;
    border-color: #0072BC;
}

</style>



// WEBPACK FOOTER //
// src/components/home_intro.vue